import * as Yup from 'yup';
import { Region } from '../../../common/models';

export function useValidationSchema() {
  return Yup.object<Region>().shape({
    name: Yup.string().nullable().required(),
  });
}
